import type { MediaPipeFaceDetectorTfjsModelConfig } from '@tensorflow-models/face-detection/dist/tfjs/types';

export const FACE_DETECTOR_CONFIG = {
    runtime: 'tfjs',
    detectorModelUrl: 'https://cdn.n37z.com/models/v3/iqa_mobilenetv3small100_sigmoid.tflite',
} as MediaPipeFaceDetectorTfjsModelConfig;

export const FACE_DETECTOR_LOADING_TIMEOUT = 10000;
